(ns practitest.frontend.components2.dashboard.transforms.bar
  (:require [practitest.frontend.components2.dashboard.schema :as sc]))

(def BarItem
  [:map
   [:category :string]
   [:group :string]
   [:color [:maybe :string]]
   [:url-params [:map]]
   [:value number?]])

(def SeriesData
  [:map
   [:chart/legend
    [:vector
     [:map
      [:label :string]
      [:color [:maybe :string]]
      [:is-active :boolean]]]]
   [:chart/series-labels [:vector :string]]
   [:chart/data [:vector [:map
                          [:category :string]
                          [:values [:vector BarItem]]]]]])

(def max-numbers-of-categories {:double  30
                                :regular 15})

(defn data-items [{{:keys [series categories]} :chart/data
                   :chart/keys                 [colors-palette x-values-map y-values-map]}]
  (for [[cat-idx category]       (map-indexed vector categories)
        {group :name data :data} series]
    {:category   category
     :group      group
     :color      (colors-palette group)
     :url-params {:x-param (get x-values-map (keyword category) category)
                  :y-param (get y-values-map (keyword group) group)}
     :value      (nth data cat-idx 0)}))

(defn transform
  {:malli/schema [:=> [:cat [:map
                             [:chart/data sc/SeriesCategories]
                             [:chart/cell-width {:optional true} [:maybe [:enum :regular :double]]]]]
                  SeriesData]}
  [{{:keys [series categories]} :chart/data
    :chart/keys                 [colors-palette toggle-legend cell-width]
    :or                         {toggle-legend {}}
    :as                         chart}]
  (let [categories-max-num   (max-numbers-of-categories (or cell-width :regular))
        is-active-bar? #(toggle-legend (:group %) true)
        latest-categories (take-last categories-max-num categories)

        max-value (->> series (mapcat :data) (apply max 0))
        legend    (vec
                   (for [{label :name} series]
                     {:label     label
                      :color     (colors-palette label)
                      :is-active (toggle-legend label true)}))
        items     (->> chart
                       data-items
                       (filter is-active-bar?)
                       (filter #(some #{(:category %)} latest-categories))
                       (group-by :category)
                       (mapv #(zipmap [:category :values] %)))]
    (merge chart {:chart/data          items
                  :chart/legend        legend
                  :chart/series-labels (mapv :name series)
                  :chart/categories    (vec latest-categories)
                  :chart/max-value     max-value})))
